module.exports = __webpack_public_path__ + "static/media/img_card.5ada3d08.png";